<template>
  <div
    class="custom-global-skeleton assessment-progress tw-bg-[#ffffff] tw-min-w-[241px] tw-max-w-[241px] tw-p-[25px] tw-pr-[9.5px] tw-w-full tw-flex tw-flex-col tw-justify-between tw-items-start tw-flex-[1_0_0] tw-self-stretch tw-border tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-p-5 tw-rounded-[6px] tw-border-solid tw-border-[#EFF0F1] tw-gap-[20px]"
  >
    <div
      class="tw-font-Poppins tw-text-[12px] tw-font-[600] tw-text-[#211F58] tw-uppercase tw-leading-[100%] tw-tracking-[1.2px] tw-w-[100px] tw-h-[12px]"
    ></div>
    <ol
      id="progress-box"
      :class="[
        'category-container tw-w-full tw-gap-[25px] tw-mb-0 tw-py-[5px] tw-flex tw-flex-col !tw-pl-0',
      ]"
    >
      <li
        v-for="item in [0, 1, 2, 3]"
        :key="item"
        :class="[
          'tw-select-none tw-cursor-pointer tw-w-full tw-font-Poppins tw-text-[15px] tw-text-[#211F58] tw-leading-[120%] tw-pr-[9.5px]',
          activeCategory === item ? 'tw-font-[600]' : '',
        ]"
      ></li>
    </ol>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
// eslint-disable-next-line no-unused-vars
const props = defineProps({
  /** The title of assessment progress */
  title: {
    type: String,
    default: "",
  },
});
const activeCategory = ref(0);
</script>

<style lang="scss">
.assessment-progress {
  ol {
    list-style-type: none;
  }

  .category-container {
    height: 199px;
    overflow: auto;

    &.show-all {
      height: auto;
      overflow: hidden;
      padding-right: 6px;
    }
  }

  /* width */
  ::-webkit-scrollbar {
    width: 6px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    border-radius: 8px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #eff0f1;
    border-radius: 8px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #eff0f1;
  }

  .right-arrow {
    transition: transform 0.3s ease;
    transform: rotate(90deg) scale(0.6);

    &.show-all {
      transform: rotate(-90deg) scale(0.6);
    }
  }
}
</style>
